<div class="auth-layout dark-theme">
  <router-outlet></router-outlet>
</div>